module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeFistUp.png
// module id = 2431
// module chunks = 2